import { Navigate } from 'react-router-dom';
import { useParams } from "react-router";
import LegacySystemSettings from "./LegacySystemSettings.jsx";
import WellnessSettings from "./WellnessSettings.jsx";
import IntegrationSettings from "./IntegrationSettings.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import EnvironmentSettings from "./EnvironmentSettings.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import LightCtrlSettings from "./LightCtrlSettings.jsx";
import SystemSettings from "./SystemSettings.jsx";
import PalPendantSettings from "./PalPendantSettings.jsx";
import Careflow from "./Careflow.jsx";
import TestPage from "./TestPage.jsx";
import StringBuilder from "./StringBuilder.jsx";
import Shifts from "@/components/Shifts.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import SystemSettingsPage from '../pages/settings/system-settings/SystemSettingsPage.jsx';
import CloudSystemSettingsPage from '../pages/settings/system-settings/CloudSystemSettingsPage.jsx';
import WellnessSettingsPage from '../pages/settings/wellness-settings/WellnessSettingsPage.jsx';
import EnvironmentalSettingsPage from '../pages/settings/environmental-settings/EnvironmentalSettingsPage.jsx';
import ShiftSettingsPage from '../pages/settings/shift-settings/ShiftSettingsPage.jsx';
import LightControllerSettingsPage from '../pages/settings/light-controller-settings/LightControllerSettingsPage.jsx';
import PalPendantSettingsPage from '../pages/settings/palpendant-settings/PalPendantSettingsPage.jsx';
import CareflowPage from '../pages/settings/careflow/CareflowPage.jsx';
import CustomEventTextPage from '../pages/settings/custom-event-text/CustomEventTextPage.jsx';
import { getSession } from "../services/session";

const Settings = (props) => {
    let settingsContent, dData, paramVars, bData;
    paramVars = useParams();
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';

    dData = getSession();
    if (paramVars.dType === "system" && (compareRole("admin", dData?.userrole) || iAmHigherAuthority(20, dData.role_weight))){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            settingsContent = isV2 ? <CloudSystemSettingsPage /> : <SystemSettings />;
        }else{
            settingsContent = isV2 ? <SystemSettingsPage /> : <LegacySystemSettings />;
        }
    }else if (paramVars.dType === "wellness" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = isV2 ? <WellnessSettingsPage /> : <WellnessSettings />;
    }else if (paramVars.dType === "careflow" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = isV2 ? <CareflowPage /> : <Careflow />;
    }else if (paramVars.dType === "test" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = <TestPage />;
    }else if (paramVars.dType === "text_builder" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = isV2 ? <CustomEventTextPage /> : <StringBuilder />;
    }else if (paramVars.dType === "environmental" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = isV2 ? <EnvironmentalSettingsPage /> : <EnvironmentSettings />;
    }else if (paramVars.dType === "lightctrl" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = isV2 ? <LightControllerSettingsPage /> : <LightCtrlSettings />;
    }else if (paramVars.dType === "palpendant" && dData?.campusData[dData?.acnt.toString()]?.is_cloud && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = isV2 ? <PalPendantSettingsPage /> : <PalPendantSettings />;
    }else if (paramVars.dType === "shifts" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = isV2 ? <ShiftSettingsPage /> : <Shifts />;
    }else{
        settingsContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return (compareRole("admin", dData?.userrole) || iAmHigherAuthority(20, dData.role_weight)) ? (
        <>
            <SessionReload />
            {settingsContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Settings;